module.exports = __webpack_public_path__ + "img/interlude_icon.ba0cc8b2.svg";